module.exports = __webpack_public_path__ + "static/media/folder.fefd21f3.svg";